export const EVENT_TYPES = {
  ACTUAL: 'actual',
  RECORDED: 'recorded',
};
